import { AccessibilityStatementPage } from './AccessibilityStatementPage';

export default AccessibilityStatementPage;
